import type { FormsConfig } from 'config-types';

const FORMS_DATA: FormsConfig = {
  forms: [
    {
      title: 'Texas Workers Compensation Form DWC073',
      link: '/dwc073.pdf',
    },
  ],
};

export const FORMS_CONFIG = Object.freeze(FORMS_DATA);
